import { Component, EventEmitter, Input, Output, SimpleChanges, ViewChild } from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';

export interface PaginatorOptions {
  onPaginate: (item: PageEvent) => void;
}

@Component({
  selector: 'app-paginator',
  templateUrl: './paginator.component.html',
  styleUrls: ['./paginator.component.scss'],
})
export class PaginatorComponent {
  @Input()
  length: number = 0;

  @Input()
  pageSize: number = 0;

  @Input()
  pageIndex: number = 0;

  @Output()
  onPaginate: EventEmitter<any> = new EventEmitter();

  @ViewChild(MatPaginator, { static: true }) paginator!: MatPaginator;

  public dataSource = new MatTableDataSource<any>();
  public displayedColumns: string[] = [];

  constructor() {}

  ngAfterViewInit() {
    if(this.paginator) {
      this.paginator.page.subscribe((value) => {
        this.onPaginate.emit(value);
      });
  
      this.paginator._intl.itemsPerPageLabel = 'Itens por página';
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['pageIndex'] && this.paginator) {
      this.paginator.pageIndex = this.pageIndex || 0;
    }
  }
}
